<template>
  <div
    v-if="show"
    class="lobi-spinner d-flex flex-column justify-content-center align-items-center"
    :class="{'fullscreen-spinner': fullscreen}"
  >
    <div
      v-if="isSpinnerMode"
      class="text-center"
    >
      <b-spinner />
      <div
        v-if="text"
        class="mt-3"
      >
        {{ text }}
      </div>
    </div>
    <div
      v-else
      class="text-center col-sm-4"
    >
      <b-progress
        variant="info"
        :max="progressBar.target"
        show-progress
        animated
      >
        <b-progress-bar
          :value="progressBar.process"
          :label="` `"
        />
      </b-progress>
      <span>{{ getProgressBarLabel() }}</span>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';

const {mapState, mapActions, mapGetters} = createNamespacedHelpers('dataManagement');
export default {
  name: 'ContentSpinner',
  props: {
    show: Boolean,
    fullscreen: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: 'Please wait...',
    },
  },
  computed: {
    ...mapState(['progressBar']),
    isSpinnerMode() {
      return !this.progressBar.target;
    },
  },
  methods: {
    getProgressBarLabel() {
      return `${Math.round(((this.progressBar.process / this.progressBar.target) * 100))}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
.lobi-spinner {
  min-height: 100px;
  height: 100%;
}

.fullscreen-spinner {
  position: absolute;
  background-color: #FFF;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}
</style>